import { ACTION } from "./constants";
import request from "../../../../utils/request";
import { requestConfig } from "../../../../config/apiResource";
import { showMainLoader, hideMainLoader } from "../../../actions";
import {formDataGenerator} from '../../../../utils/common';


export function mdArticleList(formData, typeData, append) {
  let formDataValue, typeDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 6,
      offset: 0,
      tags: ""
    };
    formDataValue = formDataGenerator(data);
    typeDataValue = "mdArticles";
  } else {
    formDataValue = formData;
    typeDataValue = typeData;
  }
  return (dispatch) => {
    return request(requestConfig.mdArticleList(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: append ? ACTION.MD_APPEND_ARTICLE_LIST : ACTION.MD_ARTICLE_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Md Article video data: " + error);
      });
  };
}

export function mdVideosList(formData, typeData, append) {
  let formDataValue, typeDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 6,
      offset: 0,
      tags: ""
    };
    formDataValue = formDataGenerator(data);
    typeDataValue = "videos";
  } else {
    formDataValue = formData;
    typeDataValue = typeData;
  }
  return (dispatch) => {
    return request(requestConfig.mdVideosList(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: append ? ACTION.MD_APPEND_VIDEOS_LIST : ACTION.MD_VIDEOS_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Md Article video data: " + error);
      });
  };
}

export function mdVideosDetails(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.mdVideosDetails(typeData))
      .then((json) => {
        json &&
          dispatch({
            type: ACTION.GET_MDSPEAK_VIDEO_DETAILS,
            data: json.data,
          });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Top up SIP Calculator data: " + error);
      });
  };
}

export function mdInterviewArticleList(formData, typeData, append) {
  let formDataValue, typeDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 6,
      offset: 0,
      tags: ""
    };
    formDataValue = formDataGenerator(data);
    typeDataValue = "mdInterviews";
  } else {
    formDataValue = formData;
    typeDataValue = typeData;
  }
  return (dispatch) => {
    return request(requestConfig.mdInterviewArticleList(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: append ? ACTION.MD_APPEND_INTERVIEW_ARTICLE_LIST : ACTION.MD_INTERVIEW_ARTICLE_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Md Article video data: " + error);
      });
  };
}

export function mdInterviewVideosList(formData, typeData) {
  let formDataValue, typeDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 16,
      offset: 0,
      tags: ""
    };
    formDataValue = formDataGenerator(data);
    typeDataValue = "videoInteraction";
  } else {
    formDataValue = formData;
    typeDataValue = typeData;
  }
  return (dispatch) => {
    return request(requestConfig.mdInterviewVideosList(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.MD_INTERVIEW_VIDEOS_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Md Article video data: " + error);
      });
  };
}

export function getMDMsgData() {
  return dispatch => {
      return request(requestConfig.getMDMsgData())
          .then((json) => {
              json && dispatch({ type: ACTION.MD_DESK_MESSAGE, data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with Insight Md Details data: " + error)
          });
  }
}
export function knowledgestackListing() {
  return dispatch => {
      return request(requestConfig.knowledgestackListing())
          .then((json) => {
              json && dispatch({ type: ACTION.KNOWLEDGE_STACK_LISTING, data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with knowledge stack data: " + error)
          });
  }
}
export function getTuesdayTalkingPoints(formData) {
  let formDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 8,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getTuesdayTalkingPoints(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.TUESDAY_TALKING_POINTS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Talking Points data: " + error);
      });
  };
}
export function mfYearBook(formData, typeData) {
  let formDataValue, typeDataValue;
  if(!__CLIENT__){
    let data = {
      search: "",
      limit: 16,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
    typeDataValue = "yearbook";
  }else{
    formDataValue = formData;
    typeDataValue = typeData;
  }

  return (dispatch) => {
    return request(requestConfig.mfYearBook(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.MF_YEAR_BOOK, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with MF Year book data: " + error);
      });
  };
}

export function getChartScope(formData, typeData) {
  let formDataValue, typeDataValue;
  if(!__CLIENT__){
    let data = {
      search: "",
      limit: 16,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
    typeDataValue = "Chartscope";
  }else{
    formDataValue = formData;
    typeDataValue = typeData;
  }

  return (dispatch) => {
    return request(requestConfig.getChartScope(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.CHART_SCOPE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Chart Scope data: " + error);
      });
  };
}
export function getHdfcMfInsights(formData, typeData) {
  let formDataValue, typeDataValue;
  if(!__CLIENT__){
    let data = {
      search: "",
      limit: 16,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
    typeDataValue = "hdfcMfInsight";
  }else{
    formDataValue = formData;
    typeDataValue = typeData;
  }

  return (dispatch) => {
    return request(requestConfig.getHdfcMfInsights(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.GET_MF_INSIGHTS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with MF Insights data: " + error);
      });
  };
}
export function getWeekendBytes(formData) {
  let formDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 8,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }

  return (dispatch) => {
    return request(requestConfig.getWeekendBytes(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.WEEKEND_BYTES, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Weekend Bytes data: " + error);
      });
  };
}

export function getMarketReviewList(formData) {
  let formDataValue;
  if(!__CLIENT__){
    let data = {
      search:"",
      limit: 8,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
  }else{
    formDataValue = formData;
  }

  return (dispatch) => {
    return request(requestConfig.getMarketReviewList(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.MARKET_REVIEW, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Market Review data: " + error);
      });
  };
}

export function getCreditPolicy(formData, typeData) {
  let formDataValue, typeDataValue;
  if(!__CLIENT__){
    let data = {
      search: "",
      limit: 16,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
    typeDataValue = "creditPolicy";
  }else{
    formDataValue = formData;
    typeDataValue = typeData;
  }
  return (dispatch) => {
    return request(requestConfig.getCreditPolicy(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.CREDIT_POLICY, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Credit Policy data: " + error);
      });
  };
}

export function getMusingsList(formData) {
  let formDataValue;
  if(!__CLIENT__){
    let data = {
      search:"",
      limit: 8,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
  }else{
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getMusingsList(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.KNOWLEDGE_STACK_MUSINGS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Musings data: " + error);
      });
  };
}
export function knowledgeStackSubscription(formData) {
  return dispatch => {
      return request(requestConfig.knowledgeStackSubscription(formData))
          .then((json) => {
              json && dispatch({ type: ACTION.KNOWLEDGE_SUBSCRIPTION, data: json.data });
          }).catch((error) => {
              console.log("Got Error with Insight Subscription data: " + error)
          });
  }
}
export function knowledgeMDsubscribeEmail(formData) {
  return dispatch => {
      return request(requestConfig.knowledgeMDsubscribeEmail(formData))
          .then((json) => {
              json && dispatch({ type: ACTION.SUBMIT_MD_DESK_EMAIL, data: json.data });
              return json;
          }).catch((error) => {
              console.log("Got Error with Insight Subscribe Email  data: " + error)
          });
  }
}

export function getKnowledgeStackPodcast() {
  return (dispatch) => {
    return request(requestConfig.getKnowledgeStackPodcast())
      .then((json) => {
        json && dispatch({ type: ACTION.KNOWLEDGE_PODCAST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Podcast data: " + error);
      });
  };
}

export function getKnowledgeStackPodcastDetail(typeData) {
  return (dispatch) => {
    return request(requestConfig.getKnowledgeStackPodcastDetail(typeData))
      .then((json) => {
        json && dispatch({ type: ACTION.KNOWLEDGE_PODCAST_DETAIL, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Podcast data: " + error);
      });
  };
}

export function mediaHouseVideosList(formData, typeData) {

  let formDataValue, typeDataValue;
  if(!__CLIENT__){
    let data = {
      search: "",
      limit: 16,
      offset: 0
    }
    formDataValue = formDataGenerator(data);
    typeDataValue = "videos";
  }else{
    formDataValue = formData;
    typeDataValue = typeData;
  }

  return (dispatch) => {
    return request(requestConfig.mediaHouseVideosList(formDataValue, typeDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.MEDIA_HOUSE_VIDEOS_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Md Article video data: " + error);
      });
  };
}

export function getWebinarList(formData) {
  let formDataValue;
  if(!__CLIENT__){
    let data = {
      linkurl: "",
      search: "",
      year: "",
      search_in: "",
    }
    formDataValue = formDataGenerator(data);
  }else{
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getWebinarList(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.WEBINAR_LIST, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Webinar data: " + error);
      });
  };
}

export function getWebinarDetail(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.getWebinarDetail(typeData))
      .then((json) => {
        json && dispatch({ type: ACTION.WEBINAR_DETAIL_PAGE, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Webinar data: " + error);
      });
  };
}

export function knowledgestackRegister(formData) {
  return (dispatch) => {
    return request(requestConfig.knowledgestackRegister(formData))
      .then((json) => {
        json && dispatch({ type: ACTION.WEBINAR_REGISTRATION, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Registration: " + error);
      });
  };
}

export function getKnowledgestackHandbook(serverData,typeData) {
  if (serverData.url) {
    let urlArray = serverData.url.split("/");
    typeData = urlArray[urlArray.length - 1];
  }
  return (dispatch) => {
    return request(requestConfig.getKnowledgestackHandbook(typeData))
      .then((json) => {
        json && dispatch({ type: ACTION.SALES_HANDBOOK, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Handbook data: " + error);
      });
  };
}

export function getBehaviouralBlogs(formData) {
  let formDataValue;

  if (!__CLIENT__) {
    let data = {
      search: "",
      limit: 8,
      offset: 0,
    };
    formDataValue = formDataGenerator(data);
  } else {
    formDataValue = formData;
  }
  return (dispatch) => {
    return request(requestConfig.getBehaviouralBlogs(formDataValue))
      .then((json) => {
        json && dispatch({ type: ACTION.BEHAVIOURAL_BLOGS, data: json.data });
        return json;
      })
      .catch((error) => {
        console.log("Got Error with Talking Points data: " + error);
      });
  };
}
